import { NgModule }            from '@angular/core';

import { SharedModule }        from '../../shared/shared.module';
import { HeaderComponent }     from './header.component';
import { HeaderMenuComponent } from './menu/header-menu.component';
import { LangNavComponent }    from './translate/lang-nav.component';
import { SearchComponent }     from './search/search.component';
import { FocusDirective }      from './search/focus.directive';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    HeaderComponent,
    HeaderMenuComponent,
    LangNavComponent,
    SearchComponent,
    FocusDirective
  ],
  exports: [
    HeaderComponent,
    HeaderMenuComponent,
    LangNavComponent,
    SearchComponent
  ]
})
export class HeaderModule {}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/moddules/header/header.module.ts